var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo2White(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66.42 67.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_0",
    "data-name": 0
  }, /*#__PURE__*/React.createElement("g", {
    id: "LINE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.51,13.12,11.88,15.25l.95-11.79a3.2,3.2,0,0,0-6.38-.52l-1,11.79a6.4,6.4,0,0,0,5.86,6.9A6.67,6.67,0,0,0,13,21.54l11.64-2.13a3.2,3.2,0,1,0-1.16-6.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ARC"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.63,23.83a33.21,33.21,0,1,0,14-17.9A3.2,3.2,0,1,0,19,11.36,26.79,26.79,0,1,1,7.72,25.8a3.2,3.2,0,1,0-6.09-2Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2White);
export default __webpack_public_path__ + "static/media/Logo2White.b3ef0513fede4ea67fa50be579854a0a.svg";
export { ForwardRef as ReactComponent };